import {
    Exercise,
    GhostButton,
    LabelBody,
    LabelDisplay2,
    SecondaryButton,
    Spacer,
} from '../../components';
import { ExerciseStatus } from '../../interfaces';
import { ExerciseViewProps } from '../exercises';

export function Module2S1ExerciseCompleted({ onContinue }: ExerciseViewProps) {
    return (
        <Exercise title="" class="clouds">
            <Spacer />

            <LabelDisplay2 class="mb-10 text-center">
                Har du lyst til at prøve igen?
            </LabelDisplay2>
            <LabelBody class="text-center">
                Godt gået! Nu er du kommet så langt.
                <br />
                Hvis du godt kunne lide denne øvelse, kan du sætte dig et mål om
                at prøve den igen. Ellers kan du gå tilbage og prøve en af de
                andre øvelser til at få ro på tankerne.
            </LabelBody>

            <Spacer />

            <SecondaryButton
                class="my-20"
                onClick={() =>
                    onContinue({
                        status: ExerciseStatus.Completed,
                        goToNext: '2.1.goal',
                    })
                }
            >
                Jeg vil sætte mig et mål
            </SecondaryButton>
            <GhostButton
                onClick={() =>
                    onContinue({
                        status: ExerciseStatus.Completed,
                        goToNext: false,
                    })
                }
            >
                Tilbage til modulet
            </GhostButton>
        </Exercise>
    );
}
